import styled from 'styled-components';
import SVGIcon from '../../SVGIcon';
import Text from '../../BuildingBlocks/Text/Text';
import { mixins } from '../../css';

export const StyledPara = styled(Text.CopyParagraph)`
  display: inline-block;
  vertical-align: middle;
  margin: 0 0 0 ${mixins.pxToRem(10)};
  width: calc(100% - ${mixins.pxToRem(32)});
  font-size: ${mixins.pxToRem(12)};
  line-height: ${mixins.pxToRem(16)};
  line-height: 1.3;
`;

export const StyledSVG = styled(SVGIcon)`
  display: inline-block;
  vertical-align: middle;
  width: ${mixins.pxToRem(22)};
  height: ${mixins.pxToRem(22)};
`;

export const StyledAmenityContainer = styled.div`
  margin: ${mixins.pxToRem(11)} ${mixins.pxToRem(6)} ${mixins.pxToRem(11)} 0;
`;
